"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
class TagsApi extends _basic_data_hub_api.default {
  async deleteTag(tag) {
    return this._callApi({
      path: `/tags/${tag.id}`,
      method: 'delete',
      queryParams: {}
    });
  }
  async getTagById(id, projection) {
    return this._callApi({
      path: `/tags/${id}`,
      queryParams: {
        projection
      }
    });
  }
  async getTags(_ref) {
    let {
      query = {},
      projection,
      sandbox = false,
      limit,
      offset,
      group
    } = _ref;
    if (typeof query.id === 'string' && query.id.includes(',')) {
      query.id = query.id.split(',');
    }
    return this._callApi({
      path: `/tags`,
      queryParams: {
        projection,
        query,
        sandbox,
        limit,
        offset,
        group
      }
    });
  }
  async saveTag(tag) {
    tag.id = tag.id || 'new';
    const res = await this._callApi({
      path: `/tags/${tag.id}`,
      payload: {
        tag
      },
      method: 'post',
      queryParams: {}
    });
    return this.setDiff(tag, res);
  }
  async getEntitiesWithTags(entities) {
    const tags = entities.map(x => x.tags).reduce((prev, next) => prev.concat(next), []).filter(x => !!x);
    const allTags = await this.getTags({
      query: {
        id: tags
      }
    });
    entities.forEach(flow => {
      if (flow.tags) flow.tags = flow.tags.map(x => allTags.find(t => t.id === x));
    });
    return entities;
  }
}
var _default = TagsApi;
exports.default = _default;